import React from "react";
import { Overlay, Message } from "components/generic/layout";

//TODO: remove this page once confirming next page: onboarding or dashboard
export default () => (
  <Overlay>
    <Message
      title="Sign up successful!"
      text="Welcome to The Lobby!"
      showIcon
    />
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/SignUpSuccess/index.js